import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { CoreMenuModule } from '@core/components';
import { CoreCommonModule } from '@core/common.module';

import { VerticalMenuComponent } from 'app/core/layout/components/menu/vertical-menu/vertical-menu.component';
import {NgScrollbarModule} from 'ngx-scrollbar';

@NgModule({
  declarations: [VerticalMenuComponent],
  imports: [CoreMenuModule, CoreCommonModule, NgScrollbarModule, RouterModule, NgScrollbarModule],
  exports: [VerticalMenuComponent]
})
export class VerticalMenuModule {}
